import { Dispatch, SetStateAction } from 'react'

export default function BidIncrementButton(props: {
  setModalVisible: Dispatch<SetStateAction<boolean>>
}) {
  return (
    <div className="relative">
      <button
        type="button"
        className=" rounded-full w-4 h-4 bg-green text-white flex justify-center items-center opacity-100 hover:opacity-50 text-xs"
        onClick={(e) => {
          e.stopPropagation()
          props?.setModalVisible(true)
        }}
      >
        $
      </button>
    </div>
  )
}
